export const environment = {
  production: true,
  name: 'development',
  PackagingUrl: 'https://api-packaging-dev-c7b4d0g9gycnftez.westeurope-01.azurewebsites.net',
  cacheInMin: 30,
  appInsights: {
    enableAppInsights: false,
  },
  maintenanceMode: false,
  enableDownloadSection: true,
};
